import React from 'react';

import { useQueryGetMe } from '@hooks/api/user/use-query-me';

import { DesktopNav } from './components/desktop-nav';
import { MobileNav } from './components/mobile-nav';

type OwnProps = {
	isMobile?: boolean;
};

const Nav: React.FC<OwnProps> = ({ isMobile }) => {
	const { data: user } = useQueryGetMe();
	const isAuthenticated = !!user?.pm_id;

	return isMobile ? <MobileNav isAuthenticated={isAuthenticated} /> : <DesktopNav isAuthenticated={isAuthenticated} />;
};

export default Nav;
